import { useState, useCallback } from 'react';

// Services

import FormsService from '../services/forms.service';

export default function InsertClientpartialData() {
    const [insertPartialDataIsLoading, setInsertPartialDataIsLoading] = useState(false);
    const [insertPartialDataError, setInsertPartialDataError] = useState(null);
    const [insertPartialData, setInsertPartialData] = useState(null);

    // Handle Insert Partial Data

    const handleInsertPartialData = useCallback(async (data) => {
        setInsertPartialDataIsLoading(true);
        setInsertPartialDataError(null);

        try {
            const request = await FormsService.insertarClienteDataParcial(data);

            setInsertPartialData(request?.data);
            setInsertPartialDataIsLoading(false);
    
        } catch(error) {

            setInsertPartialDataIsLoading(false);
            setInsertPartialDataError(error.response?.data?.message || error.message);

        }
    }, []);

    return {
        insertPartialDataIsLoading,
        insertPartialDataError,
        insertPartialData,
        handleInsertPartialData,
    }
}
